//Icons
import { FaBriefcase, FaHome, FaUsers, FaHandshake, FaPiggyBank, FaHandHolding, FaUserCheck, FaUserTimes, FaCoins, FaUserCog, FaScroll, FaChartBar, FaSlidersH, FaClipboardList, FaLifeRing, FaSignOutAlt } from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import { BiBadge } from "react-icons/bi";
import { GiKnapsack } from "react-icons/gi";
import { BsBank, BsPhoneVibrate } from "react-icons/bs";
import { GiGalaxy } from "react-icons/gi";

// Dashboard side nav data
export const MenuData = [
    {
        label: "Switch Organization",
        icon: <FaBriefcase />,
    },
    {
        label: "Dashboard",
        icon: <FaHome />,
    },
    {
        header: "Customers",
    },

    {
        label: "Users",
        icon: <HiUsers />,
        to: `/dashboard/users`
    },
    {
        label: "Guarantors",
        icon: <FaUsers />,
    },
    {
        label: "Loans",
        icon: <GiKnapsack />,
    },
    {
        label: "Decision Models",
        icon: <FaHandshake />,
    },
    {
        label: "Savings",
        icon: <FaPiggyBank />,
    },
    {
        label: "Loan Requests",
        icon: <FaHandHolding />,
    },
    {
        label: "Whitelist",
        icon: <FaUserCheck />,
    },
    {
        label: "Karma",
        icon: <FaUserTimes />,
    },
    {
        header: "BUSINESSES",
    },
    {
        label: "Organization",
        icon: <FaBriefcase />,
    },
    {
        label: "Loan Products",
        icon: <FaHandHolding />,
    },
    {
        label: "Savings Products",
        icon: <BsBank />,
    },
    {
        label: "Fees and Charges",
        icon: <FaCoins />,
    },
    {
        label: "Transactions",
        icon: <BsPhoneVibrate />,
    },
    {
        label: "Services",
        icon: <GiGalaxy />,
    },
    {
        label: "Service Account",
        icon: <FaUserCog />,
    },
    {
        label: "Settlements",
        icon: <FaScroll />,
    },
    {
        label: "Reports",
        icon: <FaChartBar />,
    },
    {
        header: "SETTINGS",
    },
    {
        label: "Preferences",
        icon: <FaSlidersH />,
    },
    {
        label: "Fees and Pricing",
        icon: <BiBadge />,
    },
    {
        label: "Audit Logs",
        icon: <FaClipboardList />,
    },
    {
        label: "Systems Messages",
        icon: <FaLifeRing />,
    },
    {
        label: "Logout",
        icon: <FaSignOutAlt />,
    },
]